function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 71c0-16 13-28 28-28h160c16 0 34 12 39 26l19 46c5 14-3 26-18 26H28c-15 0-28-13-28-28zm28 31h456c15 0 28 12 28 28v298c0 15-13 28-28 28H28c-15 0-28-13-28-28V130c0-16 13-28 28-28z"
})));